import {generalRequest} from "../services";

export async function apiGetLocations(config) {
    return generalRequest.get(`locations`, {
        params: {
            ...config
        }
    })
}